import Raven from 'raven-js';
import quickFetch from 'quick-fetch';
import { FORMS_OBJECT_TYPE, NAMESPACE, QUICK_FETCH_VIEWS } from 'FormsUI/earlyRequest/constants';
import { quickFetchCrmObjects, quickFetchCrmObjectsWithBU, quickFetchInitialState, quickFetchInitialStateWithBU } from 'framework-listing-lib/earlyRequester/crmObjectsEarlyRequester';
import { quickFetchListingLib } from 'framework-listing-lib/earlyRequester/listingLibEarlyRequester';
import { quickFetchViews } from 'framework-listing-lib/earlyRequester/viewsEarlyRequester';
import { getSearchOptions } from 'FormsUI/earlyRequest/utils';
export async function formsListingQuickFetch({
  view,
  query
}) {
  try {
    quickFetchListingLib(FORMS_OBJECT_TYPE);
    const {
      defaultPinnedViewPromise
    } = quickFetchViews({
      objectTypeId: FORMS_OBJECT_TYPE,
      namespace: NAMESPACE,
      viewId: view
    });
    const authPromise = new Promise(resolve => {
      quickFetch.afterAuth(auth => resolve(auth));
    });
    const {
      user: currentUser
    } = await authPromise;
    const hasBusinessUnitAccess = new Set(currentUser.scopes).has('business-units-access');
    if (view && QUICK_FETCH_VIEWS.includes(view)) {
      const searchOptions = getSearchOptions({
        view,
        query,
        currentUserId: currentUser.user_id
      });
      // @ts-expect-error its fine
      makeQuickFetch({
        searchOptions,
        hasBusinessUnitAccess
      });
      return;
    }
    const viewToFetch = await defaultPinnedViewPromise;
    if (!viewToFetch || !viewToFetch.id) return;
    const searchOptions = getSearchOptions({
      view: viewToFetch,
      query,
      currentUserId: currentUser.user_id
    });
    // @ts-expect-error its fine
    makeQuickFetch({
      searchOptions,
      hasBusinessUnitAccess
    });
  } catch (err) {
    Raven.captureException(err);
  }
}
function makeQuickFetch({
  searchOptions,
  hasBusinessUnitAccess
}) {
  const quickFetchStateFunction = hasBusinessUnitAccess ? quickFetchInitialStateWithBU : quickFetchInitialState;

  /**
   * quickFetchInitialState/quickFetchInitialStateWithBU does not really represent initial state for a page load
   * so we have to leave out any specific user filter
   * Read more: https://hubspot.slack.com/archives/C021HGE3YNT/p1716368870819549
   */
  quickFetchStateFunction(Object.assign({}, searchOptions, {
    filterGroups: [],
    objectTypeId: FORMS_OBJECT_TYPE,
    hasAssociationSpecs: false,
    associationSpecs: []
  }), {
    url: '/graphql/crm'
  }, {
    variant: 'default'
  });
  const quickFetchCRMFunction = hasBusinessUnitAccess ? quickFetchCrmObjectsWithBU : quickFetchCrmObjects;
  quickFetchCRMFunction(Object.assign({}, searchOptions, {
    count: 25,
    offset: 0,
    objectTypeId: FORMS_OBJECT_TYPE,
    associationPreviews: {}
  }), {
    url: '/graphql/crm'
  }, {
    variant: 'default'
  });
}